import React, { Component } from "react";
import { render } from "react-dom";

import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import { MuiThemeProvider } from "@material-ui/core/styles";
import WarningIcon from '@material-ui/icons/Warning';

import {JssProvider} from "react-jss";
import { create } from "jss";
import { createGenerateClassName, jssPreset } from "@material-ui/core/styles";

import theme from "config/theme";

import t from "translations";

const generateClassName = createGenerateClassName({
  productionPrefix: "dpe-dialog"
});
const jss = create({
  ...jssPreset(),
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: "jss-insertion-point"
});

const StyledDialog = styled(Dialog)`
  > div > div > div > h2 {
    color: #222;
    display: flex;
    align-items: center;
  }
`;

const defaultConfig = {
  title: t.areYouSure,
  yes: t.yes,
  no: t.no,
  icon: <WarningIcon style={{ marginRight: 10 }} />
};

class ConfirmDialog extends Component {
  resolve;

  state = {
    isOpen: false,
    config: defaultConfig
  };

  static create() {
    const containerElement = document.createElement("div");
    document.body.appendChild(containerElement);
    // document.getElementById("deskpad_root").appendChild(containerElement);
    return render(<ConfirmDialog />, containerElement);
  }

  componentDidMount() {
    this.setState({ isOpen: false });
  }

  handleCancel = () => {
    this.setState({ isOpen: false });
    this.resolve(false);
  };

  handleConfirm = () => {
    this.setState({ isOpen: false });
    this.resolve(true);
  };

  show = newConfig => {
    this.setState({ isOpen: true, config: { ...defaultConfig, ...newConfig } });
    return new Promise(resolve => {
      this.resolve = resolve;
    });
  };

  render() {
    const { isOpen, config } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <JssProvider jss={jss} generateClassName={generateClassName}>
          <StyledDialog
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="md"
            open={isOpen}
          >
            <DialogTitle color="textPrimary">
              {config.icon}
              {config.title}
            </DialogTitle>
            {config.text && (
              <DialogContent style={{ color: "#222" }}>
                {config.text}
              </DialogContent>
            )}
            <DialogActions>
              <Button
                onClick={this.handleCancel}
                color="primary"
                variant="outlined"
              >
                {config.no}
              </Button>
              <Button
                onClick={this.handleConfirm}
                color="primary"
                variant="contained"
              >
                {config.yes}
              </Button>
            </DialogActions>
          </StyledDialog>
        </JssProvider>
      </MuiThemeProvider>
    );
  }
}

export default ConfirmDialog.create();
